import {enumerate} from 'ts-transformer-enumerate';
import {keys} from 'ts-transformer-keys';
import {DataObjectProperties} from '~/shared/src/utilities/dataStructure';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type DataSelectionMode = 'single' | 'all';
export const dataSelectionModes = enumerate<DataSelectionMode>();

export type DataObject = DataObjectProperties & {
    dataSelectionMode : DataSelectionMode;
    parentId? : number;
};
export type DataObjects = {
    [ label : string ] : DataObject;
};

export type ConfigData = {
    [ key : string ] : any;
}
export type Configs = {
    [ label : string ] : ConfigData;
};


export type ActionType = 'backendRequest' | 'changeData' | 'changeParams' | 'changeReferenceData' | 'fileDownload' | 'reset' | 'save' | 'sendMail';
export const actionTypes = enumerate<ActionType>();

export type Action = {
    type : ActionType;
    id? : number;
    key? : string;
    name? : string;
    function? : string;
    order : number;
    dataObjects : DataObjects;
    configs? : Configs;
    requestModule? : string;
    requestCommand? : string;
    requestParams? : {
        [ key : string ] : string;
    };
};
export const actionProps = keys<Action>();
export const requiredActionProps = keys<RequiredOf<Action>>();

export const getResolvedConfigs = ( configs : Configs ) : Configs => {
    return ( Object.keys( configs ) as string[] ).reduce(
        ( innerRetVal, configLabel ) => {
            if ( configLabel.indexOf( ':' ) !== 0 ) {
                innerRetVal[ configLabel ] = configs[ configLabel ].setting;
            }
            return innerRetVal;
        },
        {} as Configs
    );
}
